import * as _ from 'lodash';

import * as angular from 'angular';
import Colors from '../../core/styleguide/colors.service';
import { Puck } from './../../impact/impact.type';
import { FormatComboTierSpendLevelFilter } from '../../core/format/formatComboTierSpendLevel.filter';

class ImpactOverviewCtrl {
  selectedOffer;
  selectedTier;
  groupData;
  pucks;
  onUpdate;
  rfp;
  featureList;
  cachedPucks; // For deep watching
  isLoading = false; // Can we just use the loader for this?
  groupDataForSelectedTier;
  notSavingCount = 0;
  totalCount = 0;
  total12MonthGroupSavings = 0;
  aptitudePositiveColor = this.colors.aptGreen;
  aptitudeNegativeColor = this.colors.aptOrange;
  lightgray = '#d3d3d3'; // TODO: Use colors
  /**
   * The current rfp (based on the route)
   *
   * @type {rfpsApi.RfpVersionTwo}
   */
  rfpId: number;
  notSavingDial = {
    percentage: 0,
    number: 0,
    color: this.aptitudeNegativeColor,
    notColor: null,
    label: '',
  };
  formatComboTierSpendLevelFilter: FormatComboTierSpendLevelFilter;

  constructor(private colors: Colors, private OfferImpactService, $filter) {
    'ngInject';
    this.formatComboTierSpendLevelFilter = $filter('formatComboTierSpendLevel');
  }

  $onChanges(changes) {
    if (changes.groupData) {
      this.updateCountsAndSavings();
      this.updateNotSavingDial();
    }

    if (changes.selectedTier || changes.groupData) {
      this.updateTierData();
    }
  }

  getTargetSpendFormattedValue(tier, abbreviatedValue = false) {
    let label = '';
    const spendLevel = tier.targetSpendLevel || tier;
    const tierName = tier.tier ? tier.tier.name : tier.name;
    const order = tier.order + 1;
    const isPrivate = tier.tierType === 'PRIVATE';

    label = this.formatComboTierSpendLevelFilter(
      spendLevel,
      abbreviatedValue,
      true,
      tierName,
      true,
      null,
      order,
      isPrivate,
    );

    return label;
  }

  isIndividualCommit() {
    return this.selectedOffer.supportedTerms?.commitmentTypes.includes(
      'INDIVIDUAL_COMMITMENT',
    );
  }

  /**
   * Any time the data for a puck is updated, update the overview with the new data
   */
  $doCheck() {
    if (!angular.equals(this.cachedPucks, this.pucks)) {
      this.cachedPucks = angular.copy(this.pucks);
      this.updateCountsAndSavings();
      this.updateNotSavingDial();
    }
  }

  updateCountsAndSavings() {
    let notSavingCount = 0;
    let totalCount = 0;
    let total12MonthGroupSavings = 0;

    _.each(this.pucks, (puck: Puck) => {
      // Total count does not include systems for which we have no spend data.
      if (!this.OfferImpactService.noSpend(puck)) {
        totalCount++;
      }

      total12MonthGroupSavings += puck.savings;

      if (puck.savings < 0) {
        notSavingCount++;
      }
    });

    this.notSavingCount = notSavingCount;
    this.totalCount = totalCount;
    this.total12MonthGroupSavings = total12MonthGroupSavings;
  }

  /**
   * Update the Not Saving Dial
   */
  updateNotSavingDial() {
    this.notSavingDial.number = this.notSavingCount;
    this.notSavingDial.percentage = this.OfferImpactService.percentOrZero(
      this.notSavingCount,
      this.totalCount,
    );
    this.notSavingDial.label = 'of ' + this.totalCount;

    if (this.notSavingDial.percentage === 0) {
      this.notSavingDial.notColor = this.aptitudePositiveColor;
      this.notSavingDial.color = this.aptitudePositiveColor;
    } else {
      this.notSavingDial.notColor = this.lightgray;
      this.notSavingDial.color = this.aptitudeNegativeColor;
    }
  }

  updateTierData() {
    // console.log('Updating tier data...');
    // console.log(this.selectedTier);
    // console.log(this.groupData);

    // Make sure both values have been loaded / passed in
    if (this.selectedTier && this.groupData) {
      this.groupDataForSelectedTier = _.find(this.groupData.tiers, {
        tier: {
          id: this.selectedTier.id,
        },
      });
    }
  }

  update() {
    // this.updateTierData();

    this.onUpdate({
      $event: {
        selectedTier: this.selectedTier,
      },
    });
  }
}

export const ImpactOverviewComponent = {
  template: require('./impactOverview.component.html'),
  controller: ImpactOverviewCtrl,
  bindings: {
    selectedOffer: '<',
    selectedTier: '<',
    groupData: '<',
    pucks: '<',
    onUpdate: '&',
    rfp: '<',
    featureList: '<',
  },
};
